module.exports = __webpack_public_path__ + "img/product_error.f16d59b.png";